import { render, staticRenderFns } from "./settingEdit.vue?vue&type=template&id=64133c9f&scoped=true&"
import script from "./settingEdit.vue?vue&type=script&lang=js&"
export * from "./settingEdit.vue?vue&type=script&lang=js&"
import style0 from "./settingEdit.vue?vue&type=style&index=0&id=64133c9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64133c9f",
  null
  
)

export default component.exports